<template>
  <div ref="title" class="c-section-title" :data-color="textColor">
    <div class="wrap">
      <h1 ref="titleEn" :data-color="textColor">
        <slot name="titleEn"></slot>
      </h1>
    </div>
    <div class="wrap">
      <p ref="titleJa" :data-color="textColor"><slot name="titleJa"></slot></p>
    </div>

    <slot name="bg" />
  </div>
</template>

<script>
import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import Splitting from 'splitting'
import gsap from 'gsap'
export default {
  props: {
    textColor: {
      type: String,
      default: 'red'
    }
  },
  async mounted() {
    const { state } = this.$store

    this.$nextTick(async () => {
      const target1 = this.$refs.titleEn
      const target2 = this.$refs.titleJa

      await Splitting({
        target: [target1, target2],
        by: 'chars'
      })

      const tl = gsap.timeline({ paused: true })
      tl.add(function() {
        target1.classList.add('in-view')
        target2.classList.add('in-view')
      })
      tl.to(this.$refs.title.querySelectorAll('.char'), {
        y: 0,
        duration: 0.8,
        stagger: 0.014,
        delay: 0.05,
        ease: 'Power3.easeOut'
      })

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              tl.play()
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: state.isMobile ? 0.0 : 1.0 }
      )

      observer.observe(this.$el)
    })
  }
}
</script>

<style lang="scss" scoped>
.c-section-title {
  width: 100%;
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transform-origin: 0 0;

  &[data-color='red'] {
    color: var(--main-color);
  }

  &[data-color='white'] {
    color: #fff;
  }

  ::v-deep .char {
    transform: translate3d(0%, 100%, 0);
  }

  .wrap {
    display: inline-block;
    padding: 0 10px;
    transform: skew(-16deg, -6deg);
    overflow: hidden;
  }

  h1 {
    display: inline-block;
    position: relative;
    font-size: 6rem;
    transform: skew(16deg, 0deg);
    @media screen and (max-width: $breakpoint-mobile) {
      font-size: 4rem;
      line-height: 1;
    }

    ::v-deep .char {
      transform: translate3d(0%, 100%, 0);
    }

    &:after {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: block;
      background-color: var(--main-color);
      width: 120%;
      height: 100%;
      transform: skew(-16deg, 0deg) translate3d(0%, 0px, 0px);
      transform-origin: 0 0;
      transition: transform 0s 0.3s;
    }

    &[data-color='white'] {
      &:after {
        background-color: #fff;
      }
    }

    &.in-view {
      &:after {
        transform: skew(-16deg, 0deg) translate3d(100%, 0px, 0px);
        transition: transform 0.3s;
      }
    }
  }
  p {
    position: relative;
    font-size: 1.8rem;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 0.4em;
    transform: skew(16deg, 0deg);
    margin: 1.4rem 0 0;
    @media screen and (max-width: $breakpoint-mobile) {
      margin: 1rem 0 0;
    }

    &:after {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      display: block;
      background-color: var(--main-color);
      width: 120%;
      height: 100%;
      transform: skew(-16deg, 0deg) translate3d(0%, 0px, 0px);
      transform-origin: 0 0;
      transition: transform 0s 0.3s;
    }

    &[data-color='white'] {
      &:after {
        background-color: #fff;
      }
    }

    &.in-view {
      &:after {
        transform: skew(-16deg, 0deg) translate3d(100%, 0px, 0px);
        transition: transform 0.3s;
      }
    }
  }
}
</style>
